import { AnalysisScore } from "./AnalysisScore";

// Example: "en-US"
// undefined - use user's locale
const locale = undefined;

export const ComparisonCard = ({ isBaseToken, data, isLoading }) => {
  return (
    <div
      className={`${
        isBaseToken
          ? "bg-[#55A6FB1A]"
          : "border border-[#55A6FB1A] border-solid border-1"
      }
        p-4 rounded-lg`}
    >
      <div className="flex items-center gap-2 mb-4">
        {/* <Injective className="w-[38px] h-[38px]" /> */}
        <img
          alt=""
          src={`https://mygateway.io/assets/img/tokens/${data.ticker}.webp`}
          className="h-[38px] w-[38px] rounded-full bg-[#C4C4C4]"
        />
        <div className="flex gap-1">
          <span>{data.name}</span>
          <span className="text-[#FFFFFF88]">{data.ticker}</span>
        </div>
      </div>

      <div className="space-y-3">
        <div>
          <div className="text-[#FFFFFF88] text-sm">Price</div>
          <div>
            {data.price.toLocaleString(locale, { maximumFractionDigits: 4 })}{" "}
            USD{" "}
            <span className="text-[rgb(76,175,80)] text-sm">
              {data.pricePercentage.toLocaleString(locale, {
                maximumFractionDigits: 2,
              })}
              %
            </span>
          </div>
        </div>
        <div className="flex grow h-[1px] bg-[#FFFFFF0D]"></div>
        <div>
          <div className="text-[#FFFFFF88] text-sm">Market Cap</div>
          <div>
            {data.marketCap.toLocaleString(locale, {
              maximumFractionDigits: 0,
            })}{" "}
            USD
          </div>
        </div>
        <div className="flex grow h-[1px] bg-[#FFFFFF0D]"></div>

        <div className="flex gap-2 p-2 rounded-lg items-center bg-[#55A6FB1A]">
          <div className=" text-sm">Gateway Score</div>
          <div className="text-[#007DFF] font-bold text-xl">
            {isLoading
              ? "0.00"
              : data.gatewayScore.toLocaleString(locale, {
                  maximumFractionDigits: 2,
                })}
          </div>
        </div>

        <AnalysisScore
          label="Technical Analysis"
          value={isLoading ? 0 : data.technicalAnalysisScore}
          verdict="Weak"
          bgColor="bg-[#F443361A]"
        />

        <AnalysisScore
          label="Fundamental Analysis"
          value={isLoading ? 0 : data.fundamentalAnalysisScore}
          verdict="Moderate"
          bgColor="bg-[#FFCA281A]"
        />

        <AnalysisScore
          label="Social Score"
          value={isLoading ? 0 : data.socialScore}
          verdict="Strong"
          bgColor="bg-[#4CAF501A]"
        />
      </div>
    </div>
  );
};
